// extracted by mini-css-extract-plugin
var _1 = "RentalPortalMatchProvenanceLegendItem-moduleRentalPortalMatchProvenanceLegendItem__ua1o3";
export { _1 as "RentalPortalMatchProvenanceLegendItem" }
